module.exports = __webpack_public_path__ + "static/media/xinshui.9749e1ab.png";